import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  emptyKitsContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    height: 'calc(100vh - 289px)',
  },
  emptyKitsBook: {
    marginBottom: theme.spacing(5),
    width: 540,
    [theme.breakpoints.down('md')]: {
      width: 290,
    },
  },
  emptyKitsButton: {
    height: 44,
    width: 176,
    [theme.breakpoints.down('md')]: {
      width: 170,
    },
  },
}));
